import { useCallback, useEffect, useRef, useState } from "react";

// Web Speech API TTS in Spanish (Castilian).
export function useSpeech() {
  const [speaking, setSpeaking] = useState(false);
  const [supported, setSupported] = useState(true);
  const voiceRef = useRef(null);
  const utteranceRef = useRef(null);
    const wakeLockRef = useRef(null);

  useEffect(() => {
    if (!("speechSynthesis" in window)) {
      setSupported(false);
      return;
    }
    const pick = () => {
      const voices = window.speechSynthesis.getVoices();
      if (!voices.length) return;
      voiceRef.current =
        voices.find((v) => /Elvira/i.test(v.name) && v.lang === "es-ES") ||
        voices.find((v) => v.lang === "es-ES" && /female|mujer|Sabina|Helena|Laura/i.test(v.name)) ||
        voices.find((v) => v.lang === "es-ES") ||
        voices.find((v) => v.lang && v.lang.startsWith("es")) ||
        null;
    };
    pick();
    window.speechSynthesis.onvoiceschanged = pick;
  }, []);

  const speak = useCallback((text) => {
    if (!("speechSynthesis" in window) || !text) return;
    
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    utteranceRef.current = u;
    u.lang = "es-ES";
    u.rate = 0.96;
    u.pitch = 1.0;
    if (voiceRef.current) u.voice = voiceRef.current;
       u.onstart = () => {
      setSpeaking(true);
      if ("wakeLock" in navigator) {
        navigator.wakeLock.request("screen").then((wl) => { wakeLockRef.current = wl; }).catch(() => {});
      }
    };
    const releaseWakeLock = () => {
      if (wakeLockRef.current) {
        wakeLockRef.current.release().catch(() => {});
        wakeLockRef.current = null;
      }
    };
    u.onend = () => { setSpeaking(false); releaseWakeLock(); };
    u.onerror = () => { setSpeaking(false); releaseWakeLock(); };
    window.speechSynthesis.speak(u);
  }, []);

  const stop = useCallback(() => {
    if ("speechSynthesis" in window) window.speechSynthesis.cancel();
    setSpeaking(false);
  }, []);

  return { speak, stop, speaking, supported };
}
